import React, { useContext, useState } from "react";
import {
  Form,
  Checkbox,
  Input,
  Row,
  Col,
  Space,
  Typography,
  theme,
} from "antd";
import {
  cannulaOptions,
  centralLineOptions,
  peripheralCannulaOptions,
} from "../../../../Options/genExamOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import { hexToRgba } from "../../../../../../helpers/utility";
import { DoctorInitialContext } from "../../../HistoryForm/DoctorHistoryFormProvider";

const IVAccess = ({ form }) => {
  const [refresh, setRefresh] = useState(false);
  const { formData } = useContext(DoctorInitialContext);
  const { token } = theme.useToken();
  const showCannula = form.getFieldValue("peripheral_cannula");
  const showCentralLine = form.getFieldValue("central_line");
  return (
    <>
      <Typography>IV Access</Typography>
      <Row gutter={16}>
        <Col span={24}>
          <DeselectableRadioGroup
            label={"Peripheral Cannula"}
            name={"peripheral_cannula"}
            options={peripheralCannulaOptions}
            form={form}
            setRefresh={setRefresh}
          />
        </Col>

        {showCannula && showCannula !== "no" && (
          <div
            className="subsection-card"
            style={{
              borderLeft: `2px solid ${hexToRgba(
                token.colorPrimaryHover,
                0.2
              )}`,
              background: "transparent",
              marginTop: "8px",
              padding: "8px 12px",
              borderRadius: "8px",
            }}
          >
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <div>
                <Form.Item label="Cannula 1 Site" name="cannula_site1">
                  <Input placeholder="Cannula 1 Site" />
                </Form.Item>
                <Form.Item label="Cannula 1 Type" name="cannula_type1">
                  <Checkbox.Group options={cannulaOptions} />
                </Form.Item>
              </div>

              {showCannula === "yes_2" && (
                <div>
                  <Form.Item label="Cannula 2 Site" name="cannula_site2">
                    <Input placeholder="Cannula 2 Site" />
                  </Form.Item>
                  <Form.Item label="Cannula 2 Type" name="cannula_type2">
                    <Checkbox.Group options={cannulaOptions} />
                  </Form.Item>
                </div>
              )}
            </Space>
          </div>
        )}

        <Col span={24}>
          <DeselectableRadioGroup
            label={"Central Line"}
            name={"central_line"}
            options={centralLineOptions}
            form={form}
            setRefresh={setRefresh}
          />
        </Col>

        {showCentralLine === "yes" && (
          <Col xs={24} sm={12} md={10} className="iv-access-days-col">
            <Form.Item label="Cumulative Days" name="central_line_days">
              <Input
                className="nurse-assessment-days-field iv-access-days-input gen-exam-compact-input"
                addonBefore="No. of Days"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        )}
      </Row>
    </>
  );
};

export default IVAccess;
